import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Divider, Empty, Flex, Form, Image, Row, Spin, Tag, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { skills } from '../../shared'
import { getQuoteData } from '../../data'
import { ActionButton, AddAppointmentModal, Breadcrumb, MyInput, MySelect } from '../../components'
import { apiCalls } from '../../shared/Apis'
import { CalendarOutlined, DollarOutlined, LoadingOutlined, TrophyOutlined, UserOutlined } from '@ant-design/icons'

const { Title, Text } = Typography
const GetQuotePage = () => {

    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false)  
    const [appointmodal, setAppointModal] = useState(false) 
    const [ servicelookup, setServiceLookup ] = useState([])
    const [ professionalID, setProfessionalID ] = useState('')
    const [ getQuoteData, setGetQuoteData ] = useState([])
    const [ selectedservice, setSelectedService ] = useState([])

    

    useEffect(()=>{
        getService()
    },[])

    const getService = async () => {
        let result= await apiCalls?.serviceApi?.getService()
        if(result)
        setServiceLookup(result)
    }

    const getProfessionalsByServices = async () => {
        setLoading(true);
        try {
            let result = await apiCalls?.getquoteApi?.getProfessionalsByServices({ servicesID: selectedservice });
            if (result) {
                setGetQuoteData(result);
                const professional = result.find(fin => fin.id);
                setProfessionalID(professional ? professional.id : null);
            } else {
                setProfessionalID(null);
            }
        } catch (error) {
            console.error("Error fetching professionals:", error);
            setProfessionalID(null);
        }
        setLoading(false);
    }
    

    
    return (
        <>
            <Breadcrumb title='Get A Quote' pageName='Get A Quote' breadcrumb={[{to:'/',name:'Home'}]}/>
            {/* <div className='padding-t'>
                <div className='container'>
                    <Row gutter={[24, 24]} justify={'center'}>
                        <Col span={24}>
                            <Flex vertical align='center'>
                                <Title level={2} className='m-0 gradient-text'>Are you looking for a <strong className='text-brand'>Pro</strong>?</Title>
                                <UnderlineDesign />
                            </Flex>
                        </Col>
                        <Col lg={{span: 8}} md={{span: 10}} xs={{span: 24}} sm={{span: 24}}>
                            <SearchInput 
                                name='search'
                                suffix={<img src='/assets/icons/search.png' width={16} />}  
                                placeholder='Search pro ...'
                                style={{width: '100%'}}
                            />
                        </Col>
                        <Col lg={{span: 8}} md={{span: 10}} xs={{span: 24}} sm={{span: 24}}>
                            <SearchInput 
                                name='where'
                                placeholder='location'
                                suffix={<img src='/assets/icons/location.png' width={16} />}
                            />
                        </Col>
                        <Col lg={{span: 4}} md={{span:4}} sm={{span: 24}} xs={{span: 24}}>
                            <Button className='btn'>Search</Button>
                        </Col>
                        <Col span={24}>
                            <ProCards {...{visible,setVisible}} />
                        </Col>
                    </Row>
                </div>
            </div> */}
            <div className='container padding-t'>   
                <Row gutter={[24,24]} className='mbl-reverse mb-3'>
                    <Col lg={{span: 15}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                        <Card className='bg-transparent border0 shadow rounded'> 
                            <Flex vertical gap={40}>
                                <Flex vertical gap={10}>
                                    <Title level={1} className='m-0 gradient-text'>
                                        Get a Quote
                                    </Title>
                                    <Text className='text-gray'>
                                        Fill the form below accurately indicating your potentials and suitability to pro applying for.
                                    </Text>
                                </Flex> 
                                <Form
                                    form={form}
                                    layout='vertical'
                                    requiredMark={false}
                                >
                                    <Row gutter={[16, 16]}>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MySelect
                                                label='Choose Service'
                                                name='servicesID'
                                                required
                                                message='Please enter work'
                                                options={servicelookup}
                                                mode={'multiple'}
                                                showSearch
                                                onChange={(value) => setSelectedService(value)}
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MySelect
                                                label='Date of project'
                                                name='dateOfProject'
                                                required
                                                message='Please enter date of project'
                                                options={[
                                                    {
                                                        id: 1,
                                                        name: 'Urgent'
                                                    },
                                                    {
                                                        id: 2,
                                                        name: 'Flexible'
                                                    }
                                                ]}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <MyInput
                                                textArea
                                                label='Project description'
                                                name='description'
                                                required
                                                message='Please enter project description'
                                                placeholder='write description...'
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MyInput
                                                label='Budget (min)'
                                                name='budgetMin'
                                                required
                                                message='Please enter budget (min)'
                                                placeholder=''
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MyInput
                                                label='Budget (max)'
                                                name='budgetMax'
                                                required
                                                message='Please enter budget (max)'
                                                placeholder=''
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                            <Button className="btn mt-2"
                                                loading={loading}
                                                onClick={() => {
                                                    getProfessionalsByServices()
                                                }}
                                            >
                                                Choose a Service
                                            </Button>
                                        </Col>
                                        {
                                            loading ? (
                                                <Col span={24}>
                                                    <Flex justify="center" align="center" className="h-100 w-100 mt-3">
                                                        <Spin
                                                            indicator={<LoadingOutlined className="text-brand" spin />}
                                                            size="large"
                                                        />
                                                    </Flex>
                                                </Col>
                                            ) : Array.isArray(getQuoteData) && getQuoteData.length > 0 ? (
                                                getQuoteData.map((professional, index) => (
                                                    <Col span={12} key={index}>
                                                        <Card className="border-brand">
                                                            <Flex vertical gap={3} className="mb-2">
                                                                <Flex justify="space-between" align="center">
                                                                    <Title level={5} className="m-0">
                                                                        {professional?.businessName}
                                                                    </Title>
                                                                    <ActionButton
                                                                        title="Add Appointment"
                                                                        className="border0 brown-bg text-white"
                                                                        icon={
                                                                            <img
                                                                                src="/assets/icons/appoint.png"
                                                                                width={30}
                                                                                alt="Add Appointment"
                                                                            />
                                                                        }
                                                                        onClick={() => setAppointModal(true)}
                                                                    />
                                                                </Flex>
                                                                <Text type="secondary" strong className="fs-14">
                                                                    {professional?.name}
                                                                </Text>
                                                            </Flex>
                                                            <Divider className="my-2" />
                                                            <Row gutter={[16, 12]}>
                                                                <Col span={12}>
                                                                    <Flex align="center" gap={5}>
                                                                        <div className="fs-16">
                                                                            <DollarOutlined />
                                                                        </div>
                                                                        <Text className="fs-14">{professional?.salary} salary</Text>
                                                                    </Flex>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <Flex align="center" gap={5}>
                                                                        <div className="fs-16">
                                                                            <TrophyOutlined />
                                                                        </div>
                                                                        <Text className="fs-14">{professional?.exp}</Text>
                                                                    </Flex>
                                                                </Col>
                                                                <Col span={12}>
                                                                    <Flex align="center" gap={5}>
                                                                        <div className="fs-16">
                                                                            <CalendarOutlined />
                                                                        </div>
                                                                        <Text className="fs-14">{professional?.date}</Text>
                                                                    </Flex>
                                                                </Col>
                                                            </Row>
                                                            <Divider className="my-2" />
                                                            <Text className="fs-14">Skills</Text>
                                                            <Flex gap={5} wrap>
                                                                {
                                                                    professional?.services?.map((data)=>
                                                                        <Tag className='brand-text border-brand'>
                                                                            {data?.name}
                                                                        </Tag>
                                                                    )
                                                                }
                                                            </Flex>
                                                        </Card>
                                                    </Col>
                                                ))
                                            ) : (
                                                <Flex justify="center" className="w-100">
                                                    <Empty description="No Data" />
                                                </Flex>
                                            )
                                        }
                                    </Row>
                                </Form>
                            </Flex>
                        </Card>
                    </Col>
                    <Col lg={{span: 9}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                        <Flex vertical gap={0} align='center' className='mt-3'>
                            <Title className='gradient-text'>Quote for a Pro !</Title>
                            <Image src="/assets/images/bid.png" alt="Nextdoor Pros" preview={false} />
                            <Flex className='mt-3' gap={20}>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/twitter.png' width={'30px'} preview={false} />
                                </Link>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/facebook.png' width={'30px'} preview={false} />
                                </Link>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/linkedin.png' width={'30px'} preview={false} />
                                </Link>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/insta.png' width={'30px'} preview={false} />
                                </Link>
                            </Flex>
                        </Flex>
                    </Col>
                </Row>
            </div>
            <AddAppointmentModal
                visible={appointmodal}
                form={form}
                professionalID={professionalID}
                onClose={() => setAppointModal(false)}
            />
        </>
    )
}

export { GetQuotePage }